import * as methods from '../methods';
import { Resource } from '../Resource';
const rootPath = 'me/preferences';
const preferences = Resource((requesterBuilder, { getCtx }) => {
    const host = getCtx().hosts.ts;
    const fromRaw = (x) => x;
    const toRaw = fromRaw;
    const get = () => methods.get({
        fromRaw,
        requesterBuilder,
        rootPath,
        host,
        cacheConfig: { gcTime: 20 * 60 * 1000, staleTime: 20 * 60 * 1000 }
    })();
    return {
        get,
        delete: () => methods.deletion({ rootPath, host, requesterBuilder })(),
        update: () => methods.update({
            rootPath,
            fromRaw: () => {
                return undefined;
            },
            parse: async (x) => x,
            toRaw,
            requesterBuilder,
            host,
            method: 'POST',
            buildKeysToInvalidate: () => [get().invalidationKey]
        })()
    };
});
export default preferences;
